import type { IconProps } from './types'

export const LogoutIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M10 6.25H7.75C6.50736 6.25 5.5 7.25736 5.5 8.5V15.5C5.5 16.7426 6.50736 17.75 7.75 17.75H10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M13 8.25L17 12L13 15.75"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 12H17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}
